export const PURCHASE_ORDER_STATUS_PREPARING = 'preparing';

const LEGACY_PREPARING_STATUSES = ['requested', 'in_review'];

export const getCanonicalPurchaseOrderStatus = (status) => {
  const normalized = String(status || '').trim().toLowerCase();
  if (LEGACY_PREPARING_STATUSES.includes(normalized)) return PURCHASE_ORDER_STATUS_PREPARING;
  return normalized;
};

export const isPurchaseOrderPreparingStatus = (status) =>
  getCanonicalPurchaseOrderStatus(status) === PURCHASE_ORDER_STATUS_PREPARING;

export const PURCHASE_ORDER_STATUS_LABELS = {
  preparing: 'En preparación',
  requested: 'En preparación',
  in_review: 'En preparación',
  confirmed: 'Confirmada',
  on_delivery: 'En despacho',
  delivered: 'Entregada',
  cancelled: 'Cancelada',
};

export const PURCHASE_ORDER_STATUS_OPTIONS = [
  { value: PURCHASE_ORDER_STATUS_PREPARING, label: PURCHASE_ORDER_STATUS_LABELS.preparing },
  { value: 'confirmed', label: PURCHASE_ORDER_STATUS_LABELS.confirmed },
  { value: 'on_delivery', label: PURCHASE_ORDER_STATUS_LABELS.on_delivery },
  { value: 'delivered', label: PURCHASE_ORDER_STATUS_LABELS.delivered },
  { value: 'cancelled', label: PURCHASE_ORDER_STATUS_LABELS.cancelled },
];

export const getPurchaseOrderStatusLabel = (status) => {
  const normalized = getCanonicalPurchaseOrderStatus(status);
  return PURCHASE_ORDER_STATUS_LABELS[normalized] || status || 'Sin estado';
};

export const getPurchaseOrderStatusTone = (status) => {
  const normalized = getCanonicalPurchaseOrderStatus(status);
  if (normalized === PURCHASE_ORDER_STATUS_PREPARING) return 'bg-amber-100 text-amber-700 border-amber-200';
  if (normalized === 'confirmed') return 'bg-teal-100 text-teal-700 border-teal-200';
  if (normalized === 'on_delivery') return 'bg-indigo-100 text-indigo-700 border-indigo-200';
  if (normalized === 'delivered') return 'bg-emerald-100 text-emerald-700 border-emerald-200';
  if (normalized === 'cancelled') return 'bg-red-100 text-red-700 border-red-200';
  return 'bg-gray-100 text-gray-700 border-gray-200';
};

export const getPurchaseOrderActionLabel = (action) => {
  const normalized = String(action || '').trim().toLowerCase();
  if (normalized === 'accept') return 'Aceptado';
  if (normalized === 'reduce') return 'Reducido';
  if (normalized === 'remove') return 'Eliminado';
  if (normalized === 'increase') return 'Aumentado';
  return 'Pendiente';
};

export const normalizePurchaseOrderAction = (action) => String(action || '').trim().toLowerCase();

export const isPurchaseOrderModifiedAction = (action) => {
  const normalized = normalizePurchaseOrderAction(action);
  return normalized === 'reduce' || normalized === 'increase';
};

export const getPurchaseOrderItemActionLabel = (item) => {
  const status = String(item?.confirmationStatus || '').trim().toLowerCase();
  if (status === 'saved') return 'Guardado';
  if (status !== 'confirmed') return 'Pendiente';
  return getPurchaseOrderActionLabel(item?.confirmationAction);
};

export const getPurchaseOrderItemActionTone = (item) => {
  const status = String(item?.confirmationStatus || '').trim().toLowerCase();
  if (status === 'saved') return 'bg-amber-100 text-amber-800';
  if (status !== 'confirmed') return 'bg-red-100 text-red-700';
  const action = normalizePurchaseOrderAction(item?.confirmationAction);
  if (action === 'accept') return 'bg-emerald-100 text-emerald-700';
  if (isPurchaseOrderModifiedAction(action)) return 'bg-amber-100 text-amber-800';
  if (action === 'remove') return 'bg-red-100 text-red-700';
  return 'bg-gray-100 text-gray-700';
};
